import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { asList2ho2pewtsfvv as asList } from './_ArraysJs.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { toList3jhuyej2anx2q as toList } from './_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function removeAll(_this__u8e3s4, predicate) {
  return filterInPlace(_this__u8e3s4, predicate, true);
}
function filterInPlace(_this__u8e3s4, predicate, predicateResultToRemove) {
  var result = false;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.iterator_jk1svi_k$();
  while ($this$with.hasNext_bitz1p_k$())
    if (predicate($this$with.next_20eer_k$()) === predicateResultToRemove) {
      $this$with.remove_ldkf9o_k$();
      result = true;
    }
  return result;
}
function addAll(_this__u8e3s4, elements) {
  return _this__u8e3s4.addAll_4lah1e_k$(asList(elements));
}
function removeLast(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.isEmpty_y1axqb_k$()) {
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('List is empty.');
  } else {
    tmp = _this__u8e3s4.removeAt_6niowx_k$(get_lastIndex(_this__u8e3s4));
  }
  return tmp;
}
function removeLastOrNull(_this__u8e3s4) {
  return _this__u8e3s4.isEmpty_y1axqb_k$() ? null : _this__u8e3s4.removeAt_6niowx_k$(get_lastIndex(_this__u8e3s4));
}
function removeFirstOrNull(_this__u8e3s4) {
  return _this__u8e3s4.isEmpty_y1axqb_k$() ? null : _this__u8e3s4.removeAt_6niowx_k$(0);
}
function addAll_0(_this__u8e3s4, elements) {
  if (isInterface(elements, Collection()))
    return _this__u8e3s4.addAll_4lah1e_k$(elements);
  else {
    var result = false;
    var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      if (_this__u8e3s4.add_utx5q5_k$(item))
        result = true;
    }
    return result;
  }
}
function convertToListIfNotCollection(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = toList(_this__u8e3s4);
  }
  return tmp;
}
function addAll_1(_this__u8e3s4, elements) {
  var result = false;
  var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    if (_this__u8e3s4.add_utx5q5_k$(item))
      result = true;
  }
  return result;
}
//region block: exports
export {
  addAll as addAll21mdhg523wnoa,
  addAll_0 as addAll1k27qatfgp3k5,
  addAll_1 as addAll3rgorw6ix9mgp,
  convertToListIfNotCollection as convertToListIfNotCollection2y7m25iq802o0,
  removeAll as removeAll3cm9rh0qak2y6,
  removeFirstOrNull as removeFirstOrNull15yg2tczrh8a7,
  removeLastOrNull as removeLastOrNull3odnlbetbttd4,
  removeLast as removeLast3759euu1xvfa3,
};
//endregion

//# sourceMappingURL=MutableCollections.mjs.map
